module.exports = __webpack_public_path__ + "static/media/centalogo.078fecdb.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/centalogo.png
// module id = 1277
// module chunks = 0